import React, { useEffect, useMemo, useRef } from 'react';
import { useAtom } from 'jotai';
import { getProductsStructureKey, productsAtom, teamInfoAtom, visibleResultAtom } from '@/store';
import {
  initFn,
  handleRefreshQrCode,
  clearPollTimer,
  initActiveProductIndex,
} from '@/utils/subscribe';
import { usePaymentInfo } from '@/utils/usePaymentInfo';
import PayQrContent from '@/components/pay-qr-content';
import styles from './index.module.css';
import { getUrlParam, showToast } from '@/utils';
import PayResult from '../new/components/pay-result';
import BindPhone from '../new/components/bind-phone';
import BusinessModal from '../new/components/business-modal';
import { useLocaleStore } from '@/i18n/localeStore';

/**
 * 仅有扫描支付界面（目前仅用于团队版场景）
 */
const ScanUI: React.FC = () => {
  const { $t } = useLocaleStore();
  const [products] = useAtom(productsAtom);
  const [teamInfo] = useAtom(teamInfoAtom);
  const [visibleResult] = useAtom(visibleResultAtom);

  const { curProduct } = usePaymentInfo();

  const moduleRef = useRef<HTMLDivElement>(null);
  const hasCheckDefaultSeats = useRef<boolean>(false);

  const userCount = teamInfo?.member_detail?.user_count || 0;
  const productsStructureKey = useMemo(() => getProductsStructureKey(products), [products]);

  useEffect(() => {
    initFn();

    return () => {
      clearPollTimer();
    };
  }, []);

  useEffect(() => {
    if (curProduct) {
      handleRefreshQrCode();
    }
  }, [curProduct]);

  useEffect(() => {
    if (products.length) {
      // 初始化商品默认选中状态
      initActiveProductIndex();
    }
  }, [productsStructureKey]);

  useEffect(() => {
    const defaultSeats = +getUrlParam('seats');

    if (!teamInfo || !defaultSeats || hasCheckDefaultSeats.current) return;

    if (userCount > defaultSeats) {
      showToast(
        $t((v, { r }) => r(v.Text_TeamMinimumSeat, [userCount, userCount])),
        moduleRef.current as HTMLDivElement
      );
    }

    hasCheckDefaultSeats.current = true;
  }, [teamInfo]);

  return (
    <>
      <div className={styles.container} ref={moduleRef}>
        <PayQrContent showCommercialLicense />
      </div>
      {visibleResult ? <PayResult /> : null}
      <BindPhone />
      <BusinessModal />
    </>
  );
};

export default ScanUI;
